import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { CategoryResponseDto, CategoryService, FamilyResponseDto, FamilyService } from 'src/app/backend';
import { SaveCategoryDialogComponent } from 'src/app/shared/dialogs/save-category-dialog/save-category-dialog.component';
import { SaveDonationDialogComponent } from 'src/app/shared/dialogs/save-donation-dialog/save-donation-dialog.component';
import { DonationService } from '../../backend/api/donation.service';
import { BasePagedComponent } from '../../core/components/base-paged/base-paged.component';
import { DialogService } from '../../core/dialog/dialog.service';
import { AuthService } from '../../core/services/auth.service';
import { ConfirmDialogComponent } from '../../shared/dialogs/confirm-dialog/confirm-dialog.component';
import { UntypedFormControl } from '@angular/forms';

interface DonationCategoryRow {
  id: number;
  name: string;
}

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss'],
})

export class CategoriesComponent extends BasePagedComponent implements OnInit {
  data: DonationCategoryRow[] = [];
  searchQueryControl = new UntypedFormControl('');
  isLoading = false;

  constructor(
    private dialogService: DialogService,
    private categoryService: CategoryService,
    authService: AuthService,
    t: TranslateService,
    messageService: NzMessageService
  ) {
    super(authService, t, messageService);
  }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.isLoading = true;

    this.categoryService
      .apiCategoryGet({
        ...this.tableData,
        filter: JSON.stringify({
          search: this.searchQueryControl.value,
        }),
      })
      .subscribe(
        (res) => {
          this.pageLoaded(res);
          this.isLoading = false;
          this.data =
            res.results?.map((x) => ({
              id: x.id || 0,
              name: x.name || '',
            })) || [];
        },
        (err) => {
          this.isLoading = false;
        }
      );
  }

  searchCategories() {
    this.loadData();
  }


  new() {
    this.dialogService
      .open(SaveCategoryDialogComponent, {
        size: 'sm',
        closeOnClickOutside: false,
      })
      .afterClosed.subscribe((res) => {
        if (res?.saved) {
          this.loadData();
        }
      });
  }

  edit(id: number) {
    this.dialogService
      .open(SaveCategoryDialogComponent, {
        size: 'sm',
        closeOnClickOutside: false,
        data: {
          id,
        },
      })
      .afterClosed.subscribe((res) => {
        if (res?.saved) {
          this.loadData();
        }
      });
  }

  delete(id: number) {
    this.dialogService
      .open(ConfirmDialogComponent, {
        size: 'sm',
      })
      .afterClosed.subscribe((res) => {
        if (res?.confirmed) {
          this.categoryService.apiCategoryIdDelete({ id }).subscribe((res) => {
            this.loadData();
          });
        }
      });
  }
}
